export default __webpack_public_path__ + "static/media/Shipping-&-Delivery.825be64e.jpg";